{
  "manchester-bridge": {
    "width": 756,
    "height": 1008,
    "variants": [
      {
        "width": 400,
        "height": 533,
        "webp": "assets/gallery/manchester-bridge-400-3d3373360111.webp",
        "avif": "assets/gallery/manchester-bridge-400-572f1529641d.avif"
      },
      {
        "width": 640,
        "height": 853,
        "webp": "assets/gallery/manchester-bridge-640-d4cd3830c180.webp",
        "avif": "assets/gallery/manchester-bridge-640-ff7473af4242.avif"
      },
      {
        "width": 756,
        "height": 1008,
        "webp": "assets/gallery/manchester-bridge-756-aadb9869bbf8.webp",
        "avif": "assets/gallery/manchester-bridge-756-d5ac317da9ff.avif"
      }
    ]
  },
  "manchester-smiles": {
    "width": 756,
    "height": 1008,
    "variants": [
      {
        "width": 400,
        "height": 533,
        "webp": "assets/gallery/manchester-smiles-400-3684a6e23212.webp",
        "avif": "assets/gallery/manchester-smiles-400-c4b22644a2f0.avif"
      },
      {
        "width": 640,
        "height": 853,
        "webp": "assets/gallery/manchester-smiles-640-bd1673897a33.webp",
        "avif": "assets/gallery/manchester-smiles-640-98997f82b2f0.avif"
      },
      {
        "width": 756,
        "height": 1008,
        "webp": "assets/gallery/manchester-smiles-756-dc41a0140e90.webp",
        "avif": "assets/gallery/manchester-smiles-756-d442d31a472d.avif"
      }
    ]
  },
  "manchester-dinner": {
    "width": 768,
    "height": 1024,
    "variants": [
      {
        "width": 400,
        "height": 533,
        "webp": "assets/gallery/manchester-dinner-400-01eebc9d4bdc.webp",
        "avif": "assets/gallery/manchester-dinner-400-2d215bd8f273.avif"
      },
      {
        "width": 640,
        "height": 853,
        "webp": "assets/gallery/manchester-dinner-640-6a770e9487cd.webp",
        "avif": "assets/gallery/manchester-dinner-640-93947a673cc5.avif"
      },
      {
        "width": 768,
        "height": 1024,
        "webp": "assets/gallery/manchester-dinner-768-67a6dcede325.webp",
        "avif": "assets/gallery/manchester-dinner-768-173a44162456.avif"
      }
    ]
  },
  "church-portrait": {
    "width": 756,
    "height": 1008,
    "variants": [
      {
        "width": 400,
        "height": 533,
        "webp": "assets/gallery/church-portrait-400-2a4e8443d5a4.webp",
        "avif": "assets/gallery/church-portrait-400-d52a0628911b.avif"
      },
      {
        "width": 640,
        "height": 853,
        "webp": "assets/gallery/church-portrait-640-4f23a2628161.webp",
        "avif": "assets/gallery/church-portrait-640-fc499bc07ad9.avif"
      },
      {
        "width": 756,
        "height": 1008,
        "webp": "assets/gallery/church-portrait-756-ea3d9729c124.webp",
        "avif": "assets/gallery/church-portrait-756-310c240fc6b0.avif"
      }
    ]
  },
  "garden": {
    "width": 4138,
    "height": 6207,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/garden-400-8d3a807900a7.webp",
        "avif": "assets/gallery/garden-400-893955cd48c5.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/garden-640-cf1237023657.webp",
        "avif": "assets/gallery/garden-640-f1c3bd4b9e99.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/garden-1024-a9f0a60f06b6.webp",
        "avif": "assets/gallery/garden-1024-a95bf931bea9.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/garden-1440-b9b5f9a1742b.webp",
        "avif": "assets/gallery/garden-1440-293b5319cd04.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/garden-1920-106b41b9ffdc.webp",
        "avif": "assets/gallery/garden-1920-03729b6be8cd.avif"
      }
    ]
  },
  "studio": {
    "width": 3859,
    "height": 5789,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/studio-400-353fbf49b5e7.webp",
        "avif": "assets/gallery/studio-400-9b8fd76d6314.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/studio-640-acde0f20aa10.webp",
        "avif": "assets/gallery/studio-640-7b3be3781d9b.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/studio-1024-08eca17dfcc1.webp",
        "avif": "assets/gallery/studio-1024-1216c02c5620.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/studio-1440-591951f78b3d.webp",
        "avif": "assets/gallery/studio-1440-0d3437cc9074.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/studio-1920-60707830fa8e.webp",
        "avif": "assets/gallery/studio-1920-84f4b21ae35e.avif"
      }
    ]
  },
  "traditional": {
    "width": 3744,
    "height": 5616,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/traditional-400-57dc1b3658eb.webp",
        "avif": "assets/gallery/traditional-400-d6db1e563469.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/traditional-640-8af9527c997b.webp",
        "avif": "assets/gallery/traditional-640-36e9a80af22c.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/traditional-1024-12c13ab406d6.webp",
        "avif": "assets/gallery/traditional-1024-63fd18795404.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/traditional-1440-0e4552bc7a6d.webp",
        "avif": "assets/gallery/traditional-1440-236ce64833db.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/traditional-1920-f7c45877414d.webp",
        "avif": "assets/gallery/traditional-1920-59a26e21c0e2.avif"
      }
    ]
  },
  "introduction": {
    "width": 4155,
    "height": 6232,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/introduction-400-2846f3330d31.webp",
        "avif": "assets/gallery/introduction-400-6c5de2c1468a.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/introduction-640-a8e857494687.webp",
        "avif": "assets/gallery/introduction-640-82fa5020cad8.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/introduction-1024-69c19e51a39f.webp",
        "avif": "assets/gallery/introduction-1024-9eca2530c54f.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/introduction-1440-dc7b5b75729e.webp",
        "avif": "assets/gallery/introduction-1440-456b10013e9d.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/introduction-1920-8fed99e1f6e7.webp",
        "avif": "assets/gallery/introduction-1920-39f726cef604.avif"
      }
    ]
  },
  "seated": {
    "width": 4000,
    "height": 6000,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/seated-400-5b3aa228d9cd.webp",
        "avif": "assets/gallery/seated-400-0200d7d2919a.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/seated-640-954f6fd500ab.webp",
        "avif": "assets/gallery/seated-640-f6a850fcb8da.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/seated-1024-2f8d0fa215d0.webp",
        "avif": "assets/gallery/seated-1024-46dc4aae2ab3.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/seated-1440-f4ae454878f0.webp",
        "avif": "assets/gallery/seated-1440-c7649b058568.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/seated-1920-9cf83d6cd59a.webp",
        "avif": "assets/gallery/seated-1920-9ecef3d59c73.avif"
      }
    ]
  },
  "dance": {
    "width": 3791,
    "height": 5687,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/dance-400-fe7a4ac6a082.webp",
        "avif": "assets/gallery/dance-400-14278910b35e.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/dance-640-f3fe08d368a7.webp",
        "avif": "assets/gallery/dance-640-d65da928f3d9.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/dance-1024-ceaaeee44049.webp",
        "avif": "assets/gallery/dance-1024-0094aa209083.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/dance-1440-0f3690df1cbb.webp",
        "avif": "assets/gallery/dance-1440-8d5127df0cc5.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/dance-1920-2e6e0b316f5c.webp",
        "avif": "assets/gallery/dance-1920-7230a3c3df54.avif"
      }
    ]
  },
  "evening": {
    "width": 4000,
    "height": 6000,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/evening-400-90481692a281.webp",
        "avif": "assets/gallery/evening-400-18b20901c322.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/evening-640-7e7871577ecc.webp",
        "avif": "assets/gallery/evening-640-1d08eaabb18c.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/evening-1024-acd46be2dbfa.webp",
        "avif": "assets/gallery/evening-1024-691a0b5fa4d5.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/evening-1440-050873dd74c4.webp",
        "avif": "assets/gallery/evening-1440-095bdf4aa6b2.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/evening-1920-8628adec3bb8.webp",
        "avif": "assets/gallery/evening-1920-d4caab237e34.avif"
      }
    ]
  },
  "blue": {
    "width": 3883,
    "height": 5985,
    "variants": [
      {
        "width": 400,
        "height": 617,
        "webp": "assets/gallery/blue-400-3d179701f24d.webp",
        "avif": "assets/gallery/blue-400-077cce792182.avif"
      },
      {
        "width": 640,
        "height": 986,
        "webp": "assets/gallery/blue-640-3d598081ef7a.webp",
        "avif": "assets/gallery/blue-640-a99177e69f39.avif"
      },
      {
        "width": 1024,
        "height": 1578,
        "webp": "assets/gallery/blue-1024-ab5c3234f844.webp",
        "avif": "assets/gallery/blue-1024-240023651366.avif"
      },
      {
        "width": 1440,
        "height": 2220,
        "webp": "assets/gallery/blue-1440-db3c2c317214.webp",
        "avif": "assets/gallery/blue-1440-cb8e44757e89.avif"
      },
      {
        "width": 1920,
        "height": 2959,
        "webp": "assets/gallery/blue-1920-c189281fc192.webp",
        "avif": "assets/gallery/blue-1920-7bf2c695c715.avif"
      }
    ]
  },
  "intro-close": {
    "width": 4430,
    "height": 6645,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/intro-close-400-3d2caa4b5589.webp",
        "avif": "assets/gallery/intro-close-400-0d5db323e756.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/intro-close-640-09d3474697a4.webp",
        "avif": "assets/gallery/intro-close-640-76a1ffd27c89.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/intro-close-1024-b4d57cac87ba.webp",
        "avif": "assets/gallery/intro-close-1024-bf36faeadfa3.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/intro-close-1440-755678cb988f.webp",
        "avif": "assets/gallery/intro-close-1440-c1269a566c84.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/intro-close-1920-5712d7b39d98.webp",
        "avif": "assets/gallery/intro-close-1920-e492e262e420.avif"
      }
    ]
  },
  "tree": {
    "width": 4044,
    "height": 6066,
    "variants": [
      {
        "width": 400,
        "height": 600,
        "webp": "assets/gallery/tree-400-6a003f448b0e.webp",
        "avif": "assets/gallery/tree-400-193d284494da.avif"
      },
      {
        "width": 640,
        "height": 960,
        "webp": "assets/gallery/tree-640-c993cec3cce4.webp",
        "avif": "assets/gallery/tree-640-71daaab7c187.avif"
      },
      {
        "width": 1024,
        "height": 1536,
        "webp": "assets/gallery/tree-1024-48f9a2317019.webp",
        "avif": "assets/gallery/tree-1024-98133cbbd4f7.avif"
      },
      {
        "width": 1440,
        "height": 2160,
        "webp": "assets/gallery/tree-1440-61dfbd6e1a09.webp",
        "avif": "assets/gallery/tree-1440-127abe6c72de.avif"
      },
      {
        "width": 1920,
        "height": 2880,
        "webp": "assets/gallery/tree-1920-1d01d0299eea.webp",
        "avif": "assets/gallery/tree-1920-dfb140a39a1e.avif"
      }
    ]
  }
}
